<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData(onlyTrashed)">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">Clientes {{onlyTrashed ? ' removidos' : ''}}</span>
                    </template>
                    <span>Clique para actualizar</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="mr-2 mb-2" fill-height
                v-model="search"
                append-icon="search"
                label="procurar clientes..."
                clearable
                single-line
                hide-details
            ></v-text-field>

            <!--Dialog for add and edit-->
            <v-btn v-if="!onlyTrashed && permissionToAdd" color="primary" icon @click="openModal"><v-icon>add</v-icon></v-btn>
            <client-form-modal
                :active_states="active_states"
                :cities="cities"
                :categories="categories"
                :subcategories="subcategories"
                :companyTypes="companyTypes"
                :simplifiedModal="false"
                :paymentMethods="paymentMethods"
                @onFormClientDone="fetchData"
            ></client-form-modal>
        </v-toolbar>


        <v-data-table xs12 sm6 md4
            :headers="headers"
            :items="clients"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText()"
            :rows-per-page-items="Global.ROWS_PER_PAGE"
            no-results-text="nenhum resultado"
            rows-per-page-text="por página"
            :pagination.sync="pagination"
            hide-actions
            disable-initial-sort
        >
            <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" >
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.nif }}</td>
                <td class="text-xs-right">{{getClientCategoryName(props.item.category_id)}}</td>
                <td class="text-xs-right">{{getClientSubCategoryName(props.item.subcategory_id)}}</td>
                <td class="text-xs-center">{{ props.item.address ? props.item.address : 'indefinido'}}</td>
                <td class="text-xs-center"><v-chip small outline :color="props.item.active_state ? 'green' : 'red'">{{ props.item.active_state ? 'ativo' : 'inativo' }}</v-chip></td>
                <td class="text-xs-right">{{ props.item.created_at | formatDate}}</td>
                <td class="text-xs-right" style="min-width: 120px; padding-right: 10px;">
                    <v-icon v-if="!onlyTrashed" small class="mr-2" @click="showItem(props.item)">visibility</v-icon>
                    <v-icon v-if="!onlyTrashed && permissionToUpdate" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    <v-icon v-if="!onlyTrashed && permissionToDelete" small class="mr-2" @click="deleteItem(props.item)">block</v-icon>
                    <v-icon v-if="onlyTrashed" small class="mr-2" @click="restoreTrashedItem(props.item)">replay</v-icon>
                    <v-menu offset-y left v-if="!onlyTrashed">
                        <template v-slot:activator="{ on }">
                            <v-icon class="mr-2" v-ripple v-on="on">
                                arrow_drop_down
                            </v-icon>
                        </template>
                        <v-list>
                            <v-list-tile @click="openClientInvoiceModal(props.item)" :disabled="!props.item">
                                <v-list-tile-title>Faturas</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <template v-slot:footer>
                <td :colspan="headers.length">
                    <custom-pagination
                        :totalData="totalData"
                        @onPaginationChange="paginationChangeCallBack($event)"
                        :disabled="loading"
                    ></custom-pagination>
                </td>
            </template>
            <template v-if="error_fetching" slot="no-data">
                <v-btn flat color="primary" @click="fetchData(onlyTrashed)"><v-icon>refresh</v-icon></v-btn>
                <span class="text-xs-center">nenhum dado encontrado</span>
            </template>
        </v-data-table>

        <!-- Client Invoice Modal -->
         <client-invoice-modal
            :paymentMethods="paymentMethods"
         ></client-invoice-modal>

        <!--Confirmation Dialog-->
        <v-dialog persistent max-width="290" v-model="openConfirmationDialog" @close="openConfirmationDialog = false">
            <v-card>
                <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                <v-card-text class="text-xs-center">
                    <p v-if="confirmationModalOp === 1">Tens a certeza que queres eliminar <br> <b>{{selectedClient.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 2">Tens a certeza que queres <br> <span class="green--text text--darken-2">restaurar</span> <br><b>{{selectedClient.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 3">Tens a certeza que queres <br> <span class="red--text text--darken-2">eliminar permanentemente</span> <br><b>{{selectedClient.name}}</b>?</p>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="red darken-1" flat @click="confirmationDialogYes">Sim</v-btn>
                        <v-btn color="grey darken-1" flat @click="close">Não</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Button Removed clients-->
        <v-btn @click="fetchData(!onlyTrashed)" slot="activator" dark small :color="onlyTrashed ? 'red' : 'indigo'">
            {{onlyTrashed ? 'Sair de ' : ''}}Clientes removidos
        </v-btn>

        <!--<div>-->
        <!--<button @click.prevent="openMyDialog()">my button</button>-->
        <!--</div>-->


    </div>
</template>

<script>
    import Vue from 'vue';
    import {Permissions, Global} from "../../config";
    // import ConfirmationDialog from '../../ConfirmationDialog.vue';
    import {mapGetters} from 'vuex';
    import {eventBus} from "../../main";

    import ClientFormModal from '../client/FormModal.vue';
    import ClientInvoiceModal from '../client/ClientInvoiceModal.vue';
    import CustomPagination from '../extra/CustomPagination.vue';

    export default {
        created () {
            let vm = this;
            this.onClientInvoicesPaid(vm);
            this.clients = [];

        },
        beforeDestroy(){
            eventBus.$off('onInvoicesPaid');
            this.close();
        },

        data(){
            return {
                Global,
                Permissions,
                pagination: {},
                totalData: 0,
                loading: false, //loading for list of clients in the datatable
                loading_modal: false, //loading for the action buttons in form modal
                error_fetching: false,  //error for fetching list of clients in the datatable
                search: '', //search for the datatable
                openConfirmationDialog: false, //loads confirmation modal with yes or no
                headers: [
                    { text: 'Nome', align: 'left', value: 'name' },
                    { text: 'Nif', align: 'center', value: 'nif'},
                    { text: 'Categoria', align: 'center', value: 'category_name'},
                    { text: 'SubCategoria', align: 'center', value: 'subcategory_name'},
                    { text: 'Local', align: 'center', value: 'address' },
                    { text: 'Estado', align: 'center', value: 'active_state' },
                    { text: 'Adicionado em', align: 'right', value: 'created_at' },
                    { text: 'Ações', align: 'right', value: '', sortable: false }
                ],

                clients: [],
                cities: [],
                companyTypes: [],
                paymentMethods: [],
                active_states: [{id: 0, name: 'inativo'}, {id: 1, name: 'ativo'}],
                selectedIndex: -1, //the index of the selected client, useful for delete, add, update, restore, permanently delete
                onlyTrashed: false, //displays only trashed items or not
                confirmationModalOp: 0, //used for getting the confirmation actions (delete, restore, permanently delete) from confirmation modal
                newContactName: '', //used in contact tab to add a new contact

                categories: [],
                subcategories: [],

            }
        },

        components: {
            ClientFormModal,
            CustomPagination,
            ClientInvoiceModal
            // ConfirmationDialog,
        },

        watch: {
            pagination(){
                this.fetchData();
            },
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
        },

        computed: {
            ...mapGetters([
                'getNewClient',
                'getNewCompany',
                'getToken'
            ]),

            permissionToAdd(){
                return this.hasPermission(Permissions.CLIENT_ADD);
            },
            permissionToUpdate(){
                return this.hasPermission(Permissions.CLIENT_UPDATE);
            },
            permissionToDelete(){
                return this.hasPermission(Permissions.CLIENT_DELETE);
            },
            
            showClientModal: {
                get(){
                    return this.$store.getters.getShowClientModal;
                },
                set(value){
                    this.$store.dispatch('setShowClientModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            selectedClient: {
                get(){
                    return this.$store.getters.getSelectedClient;
                },
                set(value){
                    this.$store.dispatch('setSelectedClient', value);
                }
            },
            showClientInvoiceModal: {
                get() { return this.$store.getters.getShowClientInvoiceModal },
                set(value) { this.$store.dispatch('setShowClientInvoiceModal', value); },
            }, 
            clientShow: {
                get(){
                    return this.$store.getters.getClientShow;
                },
                set(value){
                    this.$store.dispatch('setClientShow', value);
                }
            },

        },

        methods: {

            paginationChangeCallBack(payload){
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },

            openClientInvoiceModal(mClient){
                this.selectedClient = mClient;
                this.showClientInvoiceModal = true;
            },

            getClientCategoryName(clientCategoryId){
                for(let i=0; i<this.categories.length; i++){
                    if(this.categories[i].id === clientCategoryId){
                        return this.categories[i].name;
                    }
                }
                return '---';
            },

            getClientSubCategoryName(clientSubCategoryId){
                for(let i=0; i<this.subcategories.length; i++){
                    if(this.subcategories[i].id === clientSubCategoryId){
                        return this.subcategories[i].name;
                    }
                }
                return '---';
            },

            noDataText(){
                return this.loading ? 'a carregar clientes ...' : 
                        this.onlyTrashed ? 'Nenhum cliente removido.' : 'nenhum cliente.';
            },

            fetchData(onlyTrashed = false){
                if(this.loading) return;
                try{
                    this.onlyTrashed = onlyTrashed;
                    let url = onlyTrashed ? 'client/trashed' : 'client';

                    this.clients = [];
                    this.loading = true;
                    this.error_fetching = false;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.get(url, {
                        params: {
                            pag_size: this.pagination.rowsPerPage,
                            pag_current: this.pagination.page,
                            sort_field: this.getSortBy(this.pagination),
                            sort_order: this.getSortDes(this.pagination),
                            search: this.search,
                        }
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.error_fetching = true;
                            this.loading = false;
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        if(onlyTrashed){
                            // this.setClients(response.data.response);
                            this.clients = response.data.response;
                        }else {
                            this.clients = response.data.response.clients;
                            // this.client_types = response.data.response.clientTypes;
                            // this.client_categories = response.data.response.clientCategories;
                            this.cities = response.data.response.cities;
                            this.companyTypes = response.data.response.companyTypes;
                            this.categories = response.data.response.clientCategory;
                            this.subcategories = response.data.response.clientSubcategory;
                            this.paymentMethods = response.data.response.paymentMethods;

                            this.totalData = response.data.response.total_data;
                        }

                        this.totalRows = this.clients.length;
                    }).catch(error => {
                        this.consoleLog(error);
                        this.error_fetching = true;
                        this.showSnackBar('Erro ao carregar lista de clientes.!', 'error');
                    }).finally(()=>{
                        this.loading = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao carregar lista de clientes!', 'error');
                    this.loading_modal = false;
                }
            },

            delete(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedClient.name;
                    Vue.axios.delete('client/'+this.selectedClient.id)
                        .then(response => {
                            this.consoleLog(response);
                            if(!response.data.success){
                                this.loading_modal = false;
                                this.handleErrorCodeMessage(response.data);
                                return;
                            }

                            this.clients.splice(this.selectedIndex, 1);
                            this.showSnackBar(name+' removido com sucesso', 'success');
                        }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao remover cliente', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedClient = this.getNewClient;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao remover cliente!', 'error');
                    this.loading_modal = false;
                }
            },

            restoreTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedClient.name;
                    Vue.axios.put('client/trashed/restore/'+this.selectedClient.id)
                        .then(response => {
                            if(!response.data.success){
                                this.loading_modal = false;
                                this.handleErrorCodeMessage(response.data);
                                return;
                            }
                            this.clients.splice(this.selectedIndex, 1);
                            this.showSnackBar(name+' restaurado com sucesso', 'success');
                        }).catch(error => {
                        // this.consoleLog(error);
                        this.showSnackBar('Erro ao restaurar cliente', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedClient = this.getNewClient;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao restaurar cliente!', 'error');
                    this.loading_modal = false;
                }
            },

            onClientInvoicesPaid(vm){
                eventBus.$on("onInvoicesPaid", function (message, color) {
                    vm.showSnackBar(message, color);
                })
            },
    

            getContactsJson(item){
                if(!item.contacts_json) return [];
                if(item.contacts_json instanceof Array)
                    return item.contacts_json;
                else
                    return JSON.parse(item.contacts_json);
            },

            showItem (item) {
                this.clientShow = true;
                this.selectedIndex = this.clients.indexOf(item);
                this.selectedClient = item;
                this.selectedClient.contacts_json = this.getContactsJson(item);
                this.showClientModal = true;
                eventBus.$emit('onClientModalOpen', true);
            },

            editItem (item) {
                this.selectedIndex = this.clients.indexOf(item);
                this.selectedClient = item;
                this.selectedClient.contacts_json = this.getContactsJson(item);
                this.showClientModal = true;
                eventBus.$emit('onClientModalOpen', true);
            },

            deleteItem (item) {
                this.confirmationModalOp = 1;
                this.selectedIndex = this.clients.indexOf(item);
                // this.$store.dispatch('setSelectedClient', item);
                this.selectedClient = item;
                this.selectedClient.contacts_json = this.getContactsJson(item);
                this.openConfirmationDialog = true;
            },

            restoreTrashedItem (item){
                this.confirmationModalOp = 2;
                this.selectedIndex = this.clients.indexOf(item);
                this.selectedClient = item;
                this.selectedClient.contacts_json = this.getContactsJson(item);
                this.openConfirmationDialog = true;
            },

            // deleteTrashedItem (item){
            //     this.confirmationModalOp = 3;
            //     this.selectedIndex = this.clients.indexOf(item);
            //     this.selectedClient = item;
            //     this.selectedClient.contacts_json = this.getContactsJson(item);
            //     this.openConfirmationDialog = true;
            // },

            close () {
                this.showClientModal = false;
                this.openConfirmationDialog = false;
                this.loading = false;
                this.newContactName = '';
                this.clientShow = false;
                if(this.$v) this.$v.$reset();
                setTimeout(() => {
                    this.selectedClient = this.getNewClient;
                    this.selectedIndex = -1
                }, 300)
            },

            openModal(){
                this.selectedClient = this.getNewClient;
                this.showClientModal = true;
                eventBus.$emit('onClientModalOpen', true);
            },

            getNewEmptyContact(){
                return { phone: '', mobile_phone: '', email: '', fax: ''}
            },

            confirmationDialogYes(){
                if(this.confirmationModalOp === 1){
                    this.delete();
                }else if(this.confirmationModalOp === 2){
                    this.restoreTrashed();
                // }else if(this.confirmationModalOp === 3){
                //     this.deleteTrashed();
                }
            },

        },


    }
</script>

<style scoped>
    .mborder {
        border: 1px solid black;
    }
</style>